<template>
    <div class="container">
        <h1>Qu'est-ce qu'une Stake Pool ?</h1>
        <p class="intro">
            La blockchain Cardano fonctionne avec du Delegated Proof of Stake, permettant au détenteur du jeton (ADA) de participer au
            fonctionnement du réseau contre des intérêts. Pour cela, il doivent choisir une Stake Pool. Qu'est-ce qu'une Stake Pool, et comment
            ça marche, tout ça ?
        </p>

        <h2 id="stakepool-definition">La Stake Pool, une cagnotte d'enjeu</h2>
        <p>
            Si vous avez lu notre article sur le <a href="/doc-cardano/qu-est-ce-que-le-delegated-proof-of-stake-dpos" title="Qu'est ce que le delegated proof of stake (DPoS) ?">Delegated
                Proof of Stake</a>, vous savez que Cardano vous permet de participer à la blockchain si vous détenez des ADAs, le jeton de Cardano.
            Mais installer, configurer, surveiller et maintenir des serveurs n'est pas un métier à la portée de tout le monde. C'est pourquoi, si vous
            n'avez pas, comme la grande majorité des gens, les compétences pour cela, Cardano a une solution pour vous: Déléguer.
        </p>

        <p>
            En clair, il s'agit de choisir un noeud du réseau et de lui conférer vos pouvoirs de vote. La Stake Pool, collectant les droits de vote d'un
            ensemble d'utilisateurs, dispose d'un enjeu plus important que si elle ne collecte pas de délégation. En conséquence, le réseau lui
            transmettra plus de transaction, et elle récupérera plus de récompenses.
        </p>

        <p>
            Les récompenses seront ensuite divisée entre la Stake Pool et ses délégants, selon les critères de fonctionnement de la Stake Pool.
        </p>

        <h2 id="stakepool-fonctionnement">Comment fonctionne une Stake Pool</h2>
        <p>
            Une Stake Pool est composé d'un <mark>relai</mark> qui distribue la blockchain sur le réseau, et d'un noeud producteur de block.
            Le relai offre un bouclier contre les attaques réseau et distribue la blockchain aux autres noeuds, tandis que le producteur sert à
            créer les blocs lorsque le réseau lui en attribue.
        </p>

        <h2 id="stakepool-division-des-recompenses">Comment sont divisés les récompenses entre la Stake Pool et ses délégants ?</h2>
        <p>
            Lorsque la Stake Pool reçoit les récompenses à la fin d'une <mark>époque</mark> (période de temps définie par la blockchain, 5 jours
            pour Cardano), les récompenses de minage sont distribuées. Commence alors la division.
        </p>

        <p>
            Chaque Stake Pool affiche 2 types de frais différents: les frais fixes et les frais variables. Les frais fixes, fixé à un minimum de 340 ADAs
            par la blockchain, sont supposés couvrir les coûts fixes de l'opérateur (machines, moyen humains, etc). Les frais variables sont un pourcentage
            des gains réalisés.
        </p>

        <p>
            Lorsque la Stake Pool reçoit les récompenses de minage, les frais fixes sont déduits immédiatement. Ensuite, sur la somme restante, les frais
            variables s'appliquent. La somme restante est alors divisées entre les différents utilisateurs, au pro-rata de leurs investissements.
            Les récompenses ne sont donc pas assurées à chaque époque, ni pour la Stake Pool (qui doit créer au moins 1 bloc), ni pour les utilisateurs.
        </p>

        <p>
            Pour les petites Stake Pools et leurs utilisateurs, les récompenses sont à calculer sur le long termes: certaines mineront un bloc toutes
            les 5 époques, d'autres tous les 20 époques. Mais comme elles sont plus petites, les profits couvriront époques précédentes.
        </p>
    </div>
</template>

<script>
import createHeader from "../../js/meta.js";

export default {
    layout: "DocLayout",
    head: createHeader({
        title: "Qu'est-ce qu'une Stakepool - Stakepool.fr",
        description:
            "Que sont et comment fonctionnent les Stakepool, ces noeuds de la blockchain Cardano auxquels on délègue de l'enjeu. Explications en détail."
    })
};
</script>